import type { AnchorHTMLAttributes, ReactNode } from "react";
import { externalLinkProps, siteLinks } from "@/config/branding";

type SiteLinkKey = keyof typeof siteLinks;

interface ExternalLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: (typeof siteLinks)[SiteLinkKey];
  children: ReactNode;
}

/** Opens go.requirementone.com destinations in a new tab. */
export function ExternalLink({ href, children, className, ...rest }: ExternalLinkProps) {
  return (
    <a href={href} className={className} {...externalLinkProps} {...rest}>
      {children}
    </a>
  );
}
